export class TranslationsService {
    locales;
    currentLocale;
    constructor(locales, defaultLocale) {
        this.locales = locales;
        this.currentLocale = defaultLocale;
        if (!this.locales[defaultLocale]) {
            throw Error(`Default locale ${defaultLocale} is not defined`);
        }
    }
    setLocale(localeCode) {
        if (!localeCode)
            throw Error(`Locale code doesnt set. Default used`);
        if (!this.locales[localeCode]) {
            throw Error(`${localeCode} is not available`);
        }
        this.currentLocale = localeCode;
    }
    t(key) {
        const locale = this.locales[this.currentLocale];
        return locale.translations[key] || key;
    }
    getLocale() {
        const locale = this.locales[this.currentLocale];
        return locale;
    }
}
